import { Grid } from '@material-ui/core';
import CustomTextField from 'components/Input/CustomTextField';
import CustomRadio from 'components/CustomRadio';
import { SET_LOCAL_SAE_REPORT } from 'store/key';

const SubjectOutcome = ({
    classes,
    remoteDetail,
    updateRemoteDetail,
    isViewOnly,
    forceErrorDisplay,
    setCauseOfDeathValid,
    dispatch,
}) => {
    const subjectOutcome = remoteDetail.subjectOutcome === null ? null : Number(remoteDetail.subjectOutcome);
    const updateValue = (key, value) => {
        if (key !== 'causeOfDeath' && remoteDetail.causeOfDeath) {
            dispatch({
                type: SET_LOCAL_SAE_REPORT,
                payload: {
                    remoteDetail: {
                        ...remoteDetail,
                        [key]: value,
                        causeOfDeath: null,
                    },
                },
            });
        } else {
            updateRemoteDetail(key, value)
        };
    };

    return <>
        <Grid container className={classes.subItem}>
            <Grid container item xs={4}>
                <CustomRadio
                    disabled={isViewOnly}
                    onChange={e => { updateValue('subjectOutcome', Number(e.target.value)) }}
                    value={subjectOutcome}
                    operators={[
                        {
                            key: 0,
                            label: 'Complete recovery',
                        },
                    ]}
                />
            </Grid>
            <Grid container item xs={4}>
                <CustomRadio
                    disabled={isViewOnly}
                    onChange={e => { updateValue('subjectOutcome', Number(e.target.value)) }}
                    value={subjectOutcome}
                    operators={[
                        {
                            key: 1,
                            label: 'Recovery with sequelae',
                        },
                    ]}
                />
            </Grid>
            <Grid container item xs={4}>
                <CustomRadio
                    disabled={isViewOnly}
                    onChange={e => { updateValue('subjectOutcome', Number(e.target.value)) }}
                    value={subjectOutcome}
                    operators={[
                        {
                            key: 2,
                            label: 'Events not yet resolved',
                        },
                    ]}
                />
            </Grid>
        </Grid>
        <Grid container item xs={12}>
            <Grid container item xs={4} alignItems='baseline'>
                <CustomRadio
                    disabled={isViewOnly}
                    onChange={e => { updateValue('subjectOutcome', Number(e.target.value)) }}
                    value={subjectOutcome}
                    operators={[
                        {
                            key: 3,
                            label: 'Unknown',
                        },
                    ]}
                />
            </Grid>
            <Grid container item xs={8} alignItems='baseline'>
                <CustomRadio
                    disabled={isViewOnly}
                    onChange={e => { updateValue('subjectOutcome', Number(e.target.value)) }}
                    value={subjectOutcome}
                    operators={[
                        {
                            key: 4,
                            label: 'Death:',
                        },
                    ]}
                    remarkParams={[
                        {
                            key: 'death',
                            params: {
                                style: { marginLeft: 15 },
                            },
                            SRadioLayoutStyle: { flex: 1, alignItems: 'baseline' },
                            SlabelLayoutStyle: { flex: 1 },
                        },
                    ]}
                />
                <Grid container item xs={10}>
                    <CustomTextField
                        label="Cause of Death"
                        value={remoteDetail.causeOfDeath}
                        validators={subjectOutcome === 4 ? ['isRequired'] : []}
                        maxLength={255}
                        isTextArea
                        textAreaMinRow={3}
                        forceErrorDisplay={forceErrorDisplay}
                        isValidValue={(isValid) => setCauseOfDeathValid(isValid)}
                        onChange={(e) => { updateValue('causeOfDeath', e.target.value) }}
                        disabled={isViewOnly || subjectOutcome !== 4}
                    />
                </Grid>
            </Grid>
        </Grid>
    </>;
};
export default SubjectOutcome;
